import AsyncDialog from "./asyncDialog";

const $ = window.jQuery;

function makeButton(text) {
    return $("<input type='button' />")
        .attr("value", text)
        .addClass("ui-button");
}

function makeUi(dialog, title, msg, details) {
    var msgDiv = $("<div>")
        .attr("title", title)
        .append($('<p>').text(msg));

    if (details) {
        msgDiv.append($('<p>')
            .append('<b>Details:</b>')
            .append('<br/>')
            .append($('<div style="white-space: pre-wrap">').text(details))
        );
    }

    msgDiv.append(makeButton("OK"))
        .on("click", "input", function () {
            dialog.closeWithResult(true);
        });

    return msgDiv;
}

function failureDialog(title, msg, details) {
    var dialog = new AsyncDialog();
    dialog.class = "fv-failure-action-dialog";
    dialog.setTarget(makeUi(dialog, title, msg, details));

    return {
        showAsync: () => dialog.showAsync()
    };
}

export default failureDialog;